export const UPLOAD_HISTORICAL_DATA_STATE = {
  EMPTY: 'EMPTY',
  REQUESTED: 'REQUESTED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};
